import { render, staticRenderFns } from "./DashboardTab.vue?vue&type=template&id=06c0e4e4&scoped=true"
import script from "./DashboardTab.vue?vue&type=script&lang=js"
export * from "./DashboardTab.vue?vue&type=script&lang=js"
import style0 from "./DashboardTab.vue?vue&type=style&index=0&id=06c0e4e4&prod&lang=scss&scoped=true"
import style1 from "./DashboardTab.vue?vue&type=style&index=1&id=06c0e4e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c0e4e4",
  null
  
)

export default component.exports